module.exports = __webpack_public_path__ + "static/img/contentRightImg2.0345e1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contentRightImg2.png
// module id = oGGC
// module chunks = 2